import CONNECT_FACEBOOK from '@/graphql/Website/Integrations/Facebook/connect.gql';
import { authClient } from '../main'

export default class GaResource {
    async connect (websiteId, accessToken, pixelId, eventName) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: CONNECT_FACEBOOK,
            variables: {
                websiteId: websiteId,
                accessToken: accessToken,
                pixelId: pixelId,
                eventName: eventName
            }
        })
    }
}